import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectContextCore } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'am-banner-benefit-disney',
  styleUrls: ['./banner-benefit-disney.component.scss'],
  templateUrl: './banner-benefit-disney.component.html',
})
export class BannerBenefitDisneyComponent implements OnInit {
  public benefitsDisney = [
    'Entrada temprana a los parques.',
    'Traslado gratuito a los parques.',
    'Entretenimiento en el resort.',
    'Fácil acceso a los parques.',
    'Estacionamiento sin costo.',
  ];

  public unSubscribe$ = new Subject<void>();
  public brand = 'almundo';

  constructor(private store$: Store<IHotelsAppState>) {}

  public ngOnInit(): void {
    this.store$
      .pipe(select(selectContextCore), takeUntil(this.unSubscribe$))
      .subscribe((context) => {
        this.brand = context.brand;
      });
  }
}
